import { Component, Input, OnInit } from '@angular/core';

import { SavedEnumsService } from 'src/app/core/services/saved-enums.service';
import { EnumsService } from '../../../core/api/services';
import { UtilityService } from '../../../core/services/utility.service';
import { BaseChipListSelectSearch } from './base/base-chip-list-select-search.component';
import { BaseChipListSelectSearchModule } from './base/base-chip-list-select.search.module';

@Component({
    selector: 'enum-chip-list-select-search',
    templateUrl: './base/base-chip-list-select-search-template.html',
    imports: [BaseChipListSelectSearchModule]
})
export class EnumChipListSelectSearchComponent
  extends BaseChipListSelectSearch
  implements OnInit
{
  @Input('enumName') input_enumName: string;

  constructor(
    private utilityService: UtilityService,
    private enumsService: EnumsService
  ) {
    super();
  }

  getItemsApi() {
    this.isFetchData = false;
    const savedEnum = SavedEnumsService.getEnum(this.input_enumName);
    if (savedEnum != null) {
      this.initLoading = false;
      this.isFetchData = true;
      this.items = savedEnum.map((item) => {
        return { name: item.value, id: item.key };
      });
    } else
      this.enumsService
        .enumsGetEnumValues({ EnumTypeName: this.input_enumName })
        .pipe(this.basePipeOperators())
        .subscribe({
          next: (items) => {
            this.isFetchData = true;
            SavedEnumsService.pushEnum({
              enumName: this.input_enumName,
              enumValue: items?.data,
            });
            this.items = items?.data?.slice(0, 30).map((item) => {
              return { name: item.value, id: item.key };
            });
          },
          error: (error) => {
            this.emitError();
          },
        });
  }

  getEnumItems(enumType: any, enumName?: string): any[] {
    if (!enumName) {
      return this.utilityService.enumToObject(enumType).map((item) => {
        return { name: item.key, id: item.value };
      });
    }

    return this.utilityService
      .enumToObjectWithTranslate(enumType, enumName)
      .map((item) => {
        return { name: item.key, id: item.value };
      });
  }
}
